var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33356 30.3334L8.72925 20.06L10.6115 19.3542C12.3473 18.7033 14.2757 18.8045 15.9338 19.6335L16.0667 19.7C17.7248 20.529 19.6532 20.6302 21.3889 19.9793L23.3185 19.2557L22.8884 26.5683C22.7641 28.681 21.0157 30.331 18.8998 30.3334C18.8983 30.3334 18.8968 30.3334 18.8953 30.3334H9.33356Z",
    fill: "url(#paint0_linear_887_4806)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 6.33325H8L8.7619 20.0475L10.6113 19.354C12.3471 18.7031 14.2755 18.8043 15.9335 19.6334L16.0665 19.6998C17.7245 20.5289 19.6529 20.6301 21.3887 19.9792L23.2813 19.2694L24 6.33325Z",
    fill: "url(#paint1_linear_887_4806)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5658 6.33325H18.728L14.1067 19.0303C14.7355 19.1409 15.3511 19.3422 15.9333 19.6334L16.0662 19.6998C16.2453 19.7894 16.4275 19.8704 16.6123 19.9429L21.5658 6.33325Z",
    fill: "#FAB215"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1764 1.90862C22.2198 1.56043 21.1933 1.79387 20.4842 2.42831C20.1656 2.71221 19.9108 3.07684 19.7546 3.50592L19.757 3.50677L18.728 6.33372H21.5658L22.2628 4.41882L24.3264 5.1699C25.7103 5.67361 27.2405 4.96005 27.7443 3.57611L23.1749 1.91298L23.1764 1.90862Z",
    fill: "#FAB215"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4806",
    x1: 22.5236,
    y1: 30.3334,
    x2: 9.33342,
    y2: 30.3334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_887_4806",
    x1: 8,
    y1: 15.6479,
    x2: 24,
    y2: 15.6479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAB215",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.15
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.12341fc2d8cbc861ac27444517494461.svg";
export { ForwardRef as ReactComponent };